"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _DeletedObject_1 = require("./_DeletedObject");
exports._DeletedObjects = {
    type: "list",
    flattened: true,
    member: {
        shape: _DeletedObject_1._DeletedObject
    }
};
//# sourceMappingURL=_DeletedObjects.js.map